module.exports = __webpack_public_path__ + "static/work-76afd7e42bc556fea64a79310a3c956e.jpg";